import { DynamicCallBack } from '../api/request';
import { ScriptAnswer } from '@safeguardproperties/corescript-react-npm/dist/types';

interface DynamicsItem {
  key: string;
  sort: number;
  default: boolean;
  outputText: string;
}

export const DefaultDynamicsFunction = async (
  questionPath: string,
  methodWithParams: string,
  _apiBase: string
): Promise<ScriptAnswer[]> => {
  let b = [] as ScriptAnswer[];
  await DynamicCallBack(methodWithParams, _apiBase)
    .get()
    .then((response) => {
      const resp = response.data as DynamicsItem[];
      b = (response.data as DynamicsItem[]).map((item) => {
        return {
          Key: item.key,
          Sort: item.sort,
          Visible: 'Y',
          MapKey: `${questionPath}~${item.sort}-${item.key}`,
          Default: item.default ? 'Y' : 'N',
          _TextOverRide: item.outputText,
          _Active: true,
          _ItemType: 'answer',
        } as ScriptAnswer;
      });
    })
    .catch((error) => {
      // Handle any errors
      console.error('Error:', error.message);
    });
  return b;
};
